/**
 * api/client.ts（Reactツリーの外）から「401を検知した」ことをApp（Reactツリーの中）へ伝える
 * ための最小限のpub/sub。mockモードでは呼ばれない（realFetchのみが発火元）。
 */
type Listener = () => void;

let listeners: Listener[] = [];

export function onUnauthenticated(cb: Listener): () => void {
  listeners.push(cb);
  return () => {
    listeners = listeners.filter((l) => l !== cb);
  };
}

export function notifyUnauthenticated(): void {
  for (const l of listeners) l();
}
